import React from 'react';

export const Close = (props: any) => {

    return (
        <img src="/static/images/close.png" width="22px" height="22px" style={{cursor: 'pointer'}} alt=""/>
    );
};